/**
 * bytes.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: "bytes"})
export class BytesPipe implements PipeTransform {

  public static prefixes : string[] = [
    "",
    "k",
    "M",
    "G",
    "T"
  ];

  protected format (value : number) : string
  {
    const index : number = Math.min(
      Math.max(Math.floor(Math.log10(value) / 3), 0),
      BytesPipe.prefixes.length - 1
    );
    const prefix : string = BytesPipe.prefixes[index];
    const major : number = value / Math.pow(10, 3 * index);
    return `${major} ${prefix}b`;
  }

  public transform (value : number) : string
  {
    if (typeof value === "number")
    {
      return this.format(value);
    }
    else
    {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/bytes.pipe.ts